import NotificationBarModel from 'aa/vue/models/NotificationBarModel';
import { THREE_D_SECURE_ERROR_CODE } from 'aa/vue/constants/shared';
import { tracking, ACTION_NAMES, APP_LOG_TYPE, PAGE_TYPES } from 'services/Tracking';
import { scrollTo } from 'helpers/scrollTo';

export function displayFeedbackToUser(message, isSuccess) {
    this.openNotification(
        new NotificationBarModel({
            success: isSuccess,
            message: message,
        }),
    );
}

export function handleProcessedPayment() {
    localStorage.removeItem('selectedPlan');
    this.$store.dispatch('plan/clearPlanInfoInSessionStorage');
    if (!this.$store.state.serverData.editPaymentRedirect || !this.isEditPayment) {
        this.openNotification(
            new NotificationBarModel({
                success: true,
                message: this.$getLocale('your_payment_information_was_successfully_updated'),
            }),
        );
    }
    const routerParams = {
        name: 'AccountMain',
    };
    if (this.$store.state.serverData.editPaymentRedirect && this.isEditPayment) {
        routerParams.query = { notification: 'update-payment' };
    }
    this.$router.push(routerParams);
}

export function handleProcessedPaymentError(data, trackingParams = {}, isSubscriber = true) {
    this.formIsProcessing = false;
    if (data.code === THREE_D_SECURE_ERROR_CODE) {
        this.setUpThreeDSecure(data.actionTokenId, true);
    } else {
        const trackingService = isSubscriber ? this.$trackingService : tracking;
        const logType = this.isSwitchPlan
            ? APP_LOG_TYPE.UPDATE_PAYMENT_FORM_ERROR
            : APP_LOG_TYPE.EDIT_PAYMENT_ERROR;

        const trackingParams = {
            appLogText: data.message || 'No message provided',
            appLogType: logType,
            appLogCode: data.code || 'No code provided',
        };

        if (this.isSwitchPlan) {
            trackingParams.pageType = PAGE_TYPES.PLAN_CHANGE_CONFIRMATION;
        }

        trackingService.trackAction(ACTION_NAMES.APP_LOG, trackingParams);

        const errorMessage = this.$getLocale('something_went_wrong_please_try_again_later');

        if (isSubscriber) {
            this.openNotification(
                new NotificationBarModel({
                    success: false,
                    message: errorMessage,
                }),
            );
        } else {
            this.formErrorMessage = errorMessage;

            if (this.errorMessageElementId) {
                const el = document.getElementById(this.errorMessageElementId);
                scrollTo.element(el);
            } else {
                scrollTo.top();
            }
        }
    }
}
